import * as React from 'react';
import { useState } from 'react';
import Row from 'antd/lib/row';
import Col from 'antd/lib/col';
import Select from 'antd/lib/select';
import Table from "antd/lib/table";
import classNames from 'classnames';
import {
    Card
} from 'one-ui-card/src/card';

const {
    Option,
} = Select;

import {
    CardNoData,
} from 'one-ui-card';

import {
    CardBillingOutstanding,
} from './outstandingcard';

import {
    CardBillingServiceName,
} from './servicenamecard';

import {
    BillingCardProps,
} from './props';

import {
    PaymentCard
} from './paymentcard';

import {
    checkCardHasError,
    CardErrorMsg,
    BillingTabErrorMsg
} from 'one-card-notification';

export const BillingCard = (
    props: BillingCardProps
) => {
    const {
        title,
        billing,
        onAccountChange,
    } = props;

    // set default screen on intital/reset screen
    let outstandingresult = (
        <div></div>
    );
    let serviceresult = (
        <div></div>
    );
    const [selectedRowIndex, setSelectedRowIndex] = useState(0);
    const sbocolumns = [
        {
            title: "Admit Date",
            dataIndex: "admitdate",
            key: "admitdate"
        },
        {
            title: "Account Name",
            dataIndex: "accountname",
            key: "accountname"
        },
        {
            title: "Location Name",
            dataIndex: "locationname",
            key: "locationname"
        },
        {
            title: "Service Type",
            key: "servicetype",
            dataIndex: "servicetype"
        },
        {
            title: "Patient Balance",
            key: "patientbalance",
            dataIndex: "patientbalance"
        },
        {
            title: "Insurance Balance",
            key: "insurancebalance",
            dataIndex: "insurancebalance"
        }
    ];

    const pbhbcolumns = [
        {
            title: "Code",
            dataIndex: "code",
            key: "code"
        },
        {
            title: "Date",
            dataIndex: "date",
            key: "date"
        },
        {
            title: "Department Name",
            dataIndex: "departmentname",
            key: "departmentname"
        },
        {
            title: "Description",
            key: "description",
            dataIndex: "description"
        },
        {
            title: "Provider Name",
            key: "providername",
            dataIndex: "providername"
        },
        {
            title: "Patient Balance",
            key: "patientbalance",
            dataIndex: "patientbalance"
        },
        {
            title: "Insurance Balance",
            key: "insurancebalance",
            dataIndex: "insurancebalance"
        }
    ];

    //Check for the API Error
    if(checkCardHasError('Billing')){
        serviceresult = (
         <>
             <CardErrorMsg />
         </>
        );
         outstandingresult = (
         <>
             <BillingTabErrorMsg />
         </>
         )
     }

    //Check for No Data
    else if (billing?.values?.length == 0 && ('selected' in billing) && billing?.selected === undefined) {
        outstandingresult = (
            <>
                <CardNoData />
            </>
        );
        serviceresult = (
            <>
                <CardNoData />
            </>
        );
    }

    let outstandingaccounts = <div></div>;
    let outstandingbalance = <div></div>;
    if (billing?.values?.length > 0) {

        outstandingaccounts = (
            <div style={{ width: "329px" }}>
              <thead
                className={"ant-table-thead"}
                style={{ lineHeight: "0.11", width: "329px" }}
              >
                <tr>
                  <th>ID</th>
                  <th>Account Name (Guarantor)</th>
                </tr>
              </thead>
              <tbody>
                {billing?.values?.map((ele: any, index: number) => (
                  <tr
                    className={`outstand-account__list-item ${classNames({
                      "state--active": index === selectedRowIndex,
                    })}`}
                    key={ele.AccountId}
                    onClick={() => {
                      onAccountChange(ele.AccountId);
                      setSelectedRowIndex(index);
                    }}
                  >
                    <td className="outstand-account__list-col">
                      <div className="text-sm">{ele.AccountId}</div>
                    </td>
                    <td className="outstand-account__list-col">
                      <div className="text-base font-medium text-uppercase">
                        {ele.AccountName}
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </div>
          );

        outstandingbalance = (
            <div style={{ width: "350px" }}>
                <div style={{ float: "left", width: "68px" }}>
                    <tr>
                        <td valign="middle" style={{ whiteSpace: "pre-wrap", paddingLeft: "0.0rem" }}>
                            Patient's Balance
                        </td>
                    </tr>
                    <tr>
                        <td valign="middle" style={{ whiteSpace: "pre-wrap", paddingLeft: "0.0rem" }}>
                            Insurance Balance
                        </td>
                    </tr>
                </div>
                <div style={{ float: "left", width: "170px" }}>
                    <tbody>
                        {billing?.selected?.balanceDetails?.filter(e => e.type === "SBO").map((ele: any) => (
                            <div>
                                <tr>
                                    <td className="outstand-account__balance-col">
                                        <div className="text-sm text-black-40" style={{ marginLeft: "2.0rem" }}>{ele.type}</div>
                                        <div className="outstand-account__balance-row">
                                            <div className="outstand-account__balance-num text-primary">
                                                {"$" + ele.patientBalance}
                                            </div>
                                            {/* <a href="#3" onClick={() => onPaymentChange(false)} className="outstand-account__balance-add-card"><CreditCardPlusOutline className="text-2xl" /></a> */}
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td className="outstand-account__balance-col">
                                        <div className="text-sm text-black-40"></div>
                                        <div className="outstand-account__balance-row">
                                            <div className="outstand-account__balance-num">
                                                <div className="text-black-85">{"$" + ele.insuranceBalance}</div>
                                            </div>
                                            {/* <a href="#3" onClick={() => onPaymentChange(false)} className="outstand-account__balance-add-card"><CreditCardPlusOutline className="text-2xl" /></a> */}
                                        </div>
                                    </td>
                                </tr>
                            </div>
                        ))}
                    </tbody>
                </div>
                <div style={{ float: "left", width: "170px" }}>
                    <tbody>
                        {billing?.selected?.balanceDetails?.filter(e => e.type === "PB/HB").map((ele: any) => (
                            <div>
                                <tr>
                                    <td className="outstand-account__balance-col">
                                        <div className="text-sm text-black-40" style={{ marginLeft: "2.0rem" }}>{ele.type}</div>
                                        <div className="outstand-account__balance-row">
                                            <div className="outstand-account__balance-num text-primary">
                                                {"$" + ele.patientBalance}
                                            </div>
                                            {/* <a href="#3" onClick={() => onPaymentChange(false)} className="outstand-account__balance-add-card"><CreditCardPlusOutline className="text-2xl" /></a> */}
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td className="outstand-account__balance-col">
                                        <div className="text-sm text-black-40"></div>
                                        <div className="outstand-account__balance-row">
                                            <div className="outstand-account__balance-num">
                                                <div className="text-black-85">{"$" + ele.insuranceBalance}</div>
                                            </div>
                                            {/* <a href="#3" onClick={() => onPaymentChange(false)} className="outstand-account__balance-add-card"><CreditCardPlusOutline className="text-2xl" /></a> */}
                                        </div>
                                    </td>
                                </tr>
                            </div>
                        ))}
                    </tbody>
                </div>
            </div>

        );

    }

    return (

        <div className="outstand-account">
            <Row type="flex" gutter={[16, 16]}>
                <Col xl={18} span={24}>
                    {(billing?.values?.length > 0) ? <CardBillingOutstanding
                        title={title}
                        outstandingaccountdetails={outstandingaccounts}
                        outstandingaccountbalance={outstandingbalance}
                    /> : <Card title={title} body={outstandingresult} />}
                </Col>
                <Col xl={6} span={24}>
                    {(billing?.values?.length > 0) ? <CardBillingServiceName
                        title={'Service Area Name'}
                        servicename={billing?.selected?.serviceAreaName}
                        paperless={billing?.selected?.paperless}
                        patientguarantor={billing?.selected?.patientsGuarantor}
                    /> : <Card title={'Service Area Name'} body={serviceresult} />}
                </Col>
            </Row>
            <Row type="flex" gutter={[16, 16]}>
                <Col xl={24} span={24}>
                    {(billing?.selected?.singleBillingDetails?.length > 0) &&
                        (
                            <Card title={'SBO Specific Accounts'}
                                body={(<Table columns={sbocolumns} dataSource={billing?.selected?.singleBillingDetails}
                                    size={'small'}
                                    pagination={{ defaultPageSize: 4, showSizeChanger: false }}
                                />)}
                            />
                        )}
                </Col>
            </Row>
            <Row type="flex" gutter={[16, 16]}>
                <Col xl={24} span={24}>
                    {(billing?.selected?.professionalBillingDetails?.length > 0) &&
                        (
                            <Card title={'PH/PB Specific Accounts'}
                                body={(<Table columns={pbhbcolumns} dataSource={billing?.selected?.professionalBillingDetails}
                                    size={'small'}
                                    pagination={{ defaultPageSize: 4, showSizeChanger: false }}
                                />)}
                            />
                        )}
                </Col>
            </Row>
            <PaymentCard
                title="Collect Payment"
                billpayment={billing?.billpayment}
                billpaymentsuccess={billing?.billpaymentsuccess}
            />
        </div>

    );
};
